import { useState } from 'react';

import English from './english';
import ELanguages from './types';

import { useIsMounted } from '../hooks';

const initialValue = English;

const language = ELanguages.ENGLISH;

export default function useLocale() {
  const [locale, setLocale] = useState(initialValue);

  useIsMounted(() => {
    if (language === ELanguages.ENGLISH) setLocale(English);
  });

  return locale;
}
